module.exports = {
  eventCategory: 'Editor UI | Tool Menu | customize',

  clickEvent: function () {
    this.trackEvent({ eventAction: 'backgrounds_set_color', eventLabel: this.color });
  }
};
